export default () => ({
  active: true,
  message: ''
})
